import {
    SIDE_MENU_OPEN,
    SIDE_MENU_CLOSE,
} from './actionTypes/menu-action-types';

export const setMenuState = (isOpen) => async (dispatch) => {
    if (isOpen) {
        dispatch({ type: SIDE_MENU_OPEN });
    } else {
        dispatch({ type: SIDE_MENU_CLOSE });
    }
};

export const toggleMenuState = () => async (dispatch, getState) => {
    const { open } = getState().menu;
    if (!open) {
        dispatch({ type: SIDE_MENU_OPEN });
    } else {
        dispatch({ type: SIDE_MENU_CLOSE });
    }
};
